// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyState_container__hZNea","text":"EmptyState_text__GYRuL","image":"EmptyState_image__rQ8mg"};